import {
  IDataPreference,
  IPreferencesUser
} from "@/features/financas/views/Indicadores/@types/type";
import { IDateRange } from "@/core/composables/F360DateShortcuts/types";
import { inject, injectable } from "inversify";
import { DIMixins, DITypes } from "@/core/@types/types";
import { type IUseLocalFiltersStoreMixins } from "@/features/financas/views/Indicadores/store/dashboard/UseLocalFilterStoreMixins";
import { type IUsePreferenceStoreMixins } from "@/core/store/userPreferences/IUsePreferenceStoreMixins";
import "reflect-metadata";
import { type IToastNotification } from "@/core/composables/notification/types";

@injectable()
export default class PreferenciasTemplate<T = unknown> {
  @inject(DIMixins.LOCAL_FILTERS_STORE)
  private localFilters!: IUseLocalFiltersStoreMixins;

  @inject(DIMixins.PREFERENCES_STORE)
  private preferenceStore!: IUsePreferenceStoreMixins;

  @inject(DITypes.NOTIFICATION)
  private notification!: IToastNotification<string>;

  protected userPreferencias: IPreferencesUser[] = [];
  protected filtrosDoCard: IDataPreference[] = [];
  protected cardId: number;

  private obterFiltrosDePreferencias(preferenciaId: string) {
    return this.userPreferencias?.find(
      (preferencias: IPreferencesUser) => preferencias._id == preferenciaId
    );
  }

  constructor(idDoCard: number) {
    this.cardId = idDoCard;
    this.userPreferencias = [];
  }

  obterFiltrosDoCard(preferenciaId: string) {
    this.userPreferencias = this.preferenceStore?.obterPreferencias();
    const preferencias = this.obterFiltrosDePreferencias(preferenciaId);

    this.filtrosDoCard = [];

    if (preferencias) {
      const filtros = preferencias.preferences.filter(
        (preferencia: IDataPreference) => preferencia.id == this.cardId
      );

      this.filtrosDoCard.push(...filtros);
    }

    return this.filtrosDoCard;
  }

  obterEmpresasIds(fieldName: string) {
    const empresasIds: string[] = this.filtrosDoCard.flatMap(
      (companiesId: IDataPreference) => {
        const hasFieldName = companiesId.fieldName == fieldName;
        if (!hasFieldName) return [];

        return typeof companiesId.fieldData == "string"
          ? companiesId.fieldData
              ?.split(",")
              .filter((_id: string) => _id.trim() !== "")
          : "";
      }
    );

    if (empresasIds != undefined && empresasIds.length >= 1) return empresasIds;

    return [];
  }

  ObterRange(fieldName: string) {
    const filtros = this.filtrosDoCard
      .filter(
        (sourceDataId: IDataPreference) => sourceDataId.fieldName == fieldName
      )
      .find((date) => date.fieldData);

    return filtros;
  }

  obterShortcut(fieldName: string): string | number | undefined {
    const shortcut = this.filtrosDoCard
      .filter((shortcut) => shortcut.fieldName == fieldName)
      .find(
        (shortcutValue) =>
          shortcutValue.fieldData || shortcutValue.fieldData == "0"
      );

    if (!shortcut?.fieldData) return undefined;

    return Number(shortcut?.fieldData);
  }

  obterShortcutPeriodo(fieldNameInicio: string, fieldNameFim: string) {
    const shortcut = this.filtrosDoCard.filter(
      (shortcut) =>
        shortcut.fieldName == fieldNameInicio ||
        shortcut.fieldName == fieldNameFim
    );

    return shortcut;
  }

  salvarFiltro(data: T) {
    if (!data)
      return this.notification.showNotification(
        "Houve um erro ao atualizar os filtros. Tente novamente mais tarde.",
        { type: "error", timeout: 3000 }
      );
    this.localFilters.saveFilter({ ...data, id: this.cardId }); //{ ...data, id: this.cardId }, data.shortcut
  }

  AtualizarFiltro(value: number, range?: IDateRange) {
    this.localFilters.updateShortcut(this.cardId, value, range);
  }

  limparFiltro() {
    this.localFilters.clearFilter(this.cardId);
  }
}
